import React from "react";

const Process = [
  {
    step: "1",
    title: "Share Your Link",
    description:
      "Copy your unique referral link and share it with colleagues and friends",
  },
  {
    step: "2",
    title: "They Sign Up",
    description: "They sign up and become a paying customer",
  },
  {
    step: "3",
    title: "You Both Win!",
    description:
      "They enjoy 50% off their first month and you receive a $50 account credit",
  },
];

const HowItWorks = () => {
  return (
    <div className="w-full mt-6 rounded-lg border border-line px-6 md:px-10 py-6 md:py-10 bg-white">
      <h1 className="text-primary text-xl md:text-2xl font-bold mb-2">
        How It Works
      </h1>
      <p className="text-content text-xs">Three simple steps to earn rewards</p>

      <div className="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5 mt-8">
        {Process.map((items, index) => (
          <div key={index} className="lg:max-w-[323px] space-y-2">
            <div className="text-sm sm:text-xl font-bold text-white bg-content rounded-full h-7 sm:h-9 w-7 sm:w-9 flex items-center justify-center">
              <span>{items.step}</span>
            </div>
            <h2 className="font-bold text-content">{items.title}</h2>
            <p className="text-content text-sm sm:text-[15px]">
              {items.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HowItWorks;
